import React from 'react';
import { motion } from 'framer-motion';

const Preloader = () => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-slate-900 text-white">
      
      {/* 1. Animated Logo */}
      <motion.div 
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="w-24 h-24 bg-blue-600 rounded-3xl flex items-center justify-center text-6xl shadow-2xl mb-6 relative overflow-hidden"
      >
        <div className="absolute top-0 right-0 w-10 h-10 bg-white opacity-20 rounded-full blur-xl"></div>
        🇮🇳
      </motion.div>

      {/* 2. Brand Name with Pulse */}
      <motion.h1 
        animate={{ opacity: [0.5, 1, 0.5] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
        className="text-3xl font-extrabold tracking-widest mb-2"
      >
        Labour<span className="text-yellow-400">Connect</span>
      </motion.h1>

      {/* 3. Loading Bar */}
      <div className="w-48 h-1 bg-slate-700 rounded-full overflow-hidden mt-4">
        <motion.div 
          initial={{ x: '-100%' }}
          animate={{ x: '100%' }}
          transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
          className="w-full h-full bg-blue-500 rounded-full"
        />
      </div>

      <p className="text-slate-500 text-xs mt-4 font-mono">Loading India's Workforce...</p>
    </div>
  );
};

export default Preloader;